const technologies = {
  frontend: [
    {
      name: "HTML5",
      icon: "devicon-html5-plain colored",
      description: "Creating semantic and accessible web page structures.",
      tag: "Frontend",
    },
    {
      name: "CSS3",
      icon: "devicon-css3-plain colored",
      description: "Building responsive layouts and modern user interfaces.",
      tag: "Frontend",
    },
    {
      name: "JavaScript",
      icon: "devicon-javascript-plain colored",
      description:
        "Developing interactive applications using modern ES6+ features.",
      tag: "Frontend",
    },
    {
      name: "React",
      icon: "devicon-react-original colored",
      description:
        "Building reusable components and interactive user interfaces.",
      tag: "Frontend",
    },
    {
      name: "TypeScript",
      icon: "devicon-typescript-plain colored",
      description:
        "Writing safer JavaScript with static typing and better tooling.",
      tag: "Frontend",
    },
  ],

  backend: [
    {
      name: "Java",
      icon: "devicon-java-plain colored",
      description: "Developing reliable backend and enterprise applications.",
      tag: "Backend",
    },
    {
      name: "Spring",
      icon: "devicon-spring-original colored",
      description:
        "Creating backend services and REST APIs with the Spring ecosystem.",
      tag: "Backend",
    },
    {
      name: "Node.js",
      icon: "devicon-nodejs-plain colored",
      description: "Building server-side applications and RESTful APIs.",
      tag: "Backend",
    },
  ],

  devops: [
    {
      name: "Docker",
      icon: "devicon-docker-plain colored",
      description: "Containerizing applications for consistent environments.",
      tag: "DevOps",
    },
    {
      name: "Kubernetes",
      icon: "devicon-kubernetes-plain colored",
      description: "Managing and orchestrating containerized applications.",
      tag: "DevOps",
    },
    {
      name: "AWS",
      icon: "devicon-amazonwebservices-plain-wordmark colored",
      description:
        "Working with cloud infrastructure and application deployment.",
      tag: "Cloud",
    },
    {
      name: "GCP",
      icon: "devicon-googlecloud-plain colored",
      description:
        "Working with cloud infrastructure and application deployment.",
      tag: "Cloud",
    },
    {
      name: "Jenkins",
      icon: "devicon-jenkins-line colored",
      description: "Automating build, testing and deployment workflows.",
      tag: "CI/CD",
    },
  ],

  databases: [
    {
      name: "SQL Server",
      icon: "devicon-microsoftsqlserver-plain colored",
      description:
        "Designing queries and managing relational application data.",
      tag: "Database",
    },
    {
      name: "Oracle",
      icon: "devicon-oracle-original colored",
      description: "Working with enterprise relational databases and SQL.",
      tag: "Database",
    },
    {
      name: "PostgreSQL",
      icon: "devicon-postgresql-plain colored",
      description: "Managing structured data in relational applications.",
      tag: "Database",
    },
    {
      name: "MongoDB",
      icon: "devicon-mongodb-plain colored",
      description: "Storing and managing flexible document-based data.",
      tag: "Database",
    },
  ],

  tools: [
    {
      name: "Git",
      icon: "devicon-git-plain colored",
      description: "Managing source code versions and collaborative workflows.",
      tag: "Tool",
    },
    {
      name: "GitHub",
      icon: "devicon-github-original",
      description: "Hosting repositories and managing project collaboration.",
      tag: "Tool",
    },
    {
      name: "VS Code",
      icon: "devicon-vscode-plain colored",
      description: "Developing and debugging applications efficiently.",
      tag: "Tool",
    },
    {
      name: "IntelliJ IDEA",
      icon: "devicon-intellij-plain colored",
      description: "Developing and debugging Java-based applications.",
      tag: "Tool",
    },
    {
      name: "Figma",
      icon: "devicon-figma-plain colored",
      description: "Creating interface mockups and planning visual designs.",
      tag: "Design",
    },
  ],
};

export default technologies;
